import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

// actions
import { doneIndicator, error } from '../../actions/standardActions';

// api
import freeStandingAppointment from '../../sources/api/freeStandingAppointment';

// constants
import { FREE_STANDING_APPOINTMENT_CREATE } from '../../constants/freeStandingAppointmentTypes';

// lib
import httpSaga from '../../lib/httpSaga';

// schemas
import { appointmentSchema } from '../../schemas/Normalizr';
import { updateRep } from '../../actions/repActions';
import { toastr } from 'react-redux-toastr';
import { tooltipHide } from '../../actions/tooltipActions';
import { FREE_STANDING_APPOINTMENT_CREATE_SUCCESS, FREE_STANDING_APPOINTMENT_CREATE_ERROR } from '../../constants/messages';

export function* freeStandingAppointmentCreate(action) {
  if (action['@@redux-saga/SAGA_ACTION']) return;

  const params = action.payload;
  const rep = action.payload.rep;

  try {
    yield *httpSaga(FREE_STANDING_APPOINTMENT_CREATE, call(freeStandingAppointment.create, params), appointmentSchema);
    if (rep && rep.size > 0) {
      yield put(updateRep(rep.toJS()));
    }
    yield put(tooltipHide({ id: params.tooltipId }));
    yield toastr.success('success', FREE_STANDING_APPOINTMENT_CREATE_SUCCESS);
  } catch (e) {
    yield toastr.error(FREE_STANDING_APPOINTMENT_CREATE_ERROR);
    yield put(error(FREE_STANDING_APPOINTMENT_CREATE, e));
  } finally {
    yield put(doneIndicator(FREE_STANDING_APPOINTMENT_CREATE));
  }
}

export function* watchFreeStandingAppointmentCreate() {
  yield takeEvery(FREE_STANDING_APPOINTMENT_CREATE, freeStandingAppointmentCreate);
}

export default function* root() {
  yield all([
    fork(watchFreeStandingAppointmentCreate)
  ]);
}



// WEBPACK FOOTER //
// ./app/sagas/freeStandingAppointment/freeStandingAppointmentCreate.js